<div class="container">
  <div class="content">
    <button *ngIf="!(isMinorThanTablet | async).matches" (click)="handleGoBack()" class="link-btn">
      <mat-icon>arrow_back</mat-icon>
      <span>Voltar</span>
    </button>
    <div class="alert">
      <app-alert [dense]="true" [hideIcon]="true" [type]="'info'" [title]="formTitle[tipoAlteracao]">
      </app-alert>
    </div>
    <app-token-confirmation 
      *ngIf="verificationMethodInfo"
      [initialValue]="verificationMethodInfo.selectedMethodData" 
      [verificationMethodType]="verificationMethodInfo.selectedMethod"
      [isInternal]="true"
      [pathToRedirectOnError]="pathToRedirectOnError"
      [enableVerificationAccount]="enableVerificationAccount"
      (onTokenConfirm)="handleConfirmToken($event)">
    </app-token-confirmation>
  </div>
  <footer class="mobile-footer">
    <span>
      <svg width="13" height="16" xmlns="http://www.w3.org/2000/svg">
        <use xlink:href="/assets/images/icons/ic-security-lock.svg#lock" fill="inherit" />
      </svg>
      Ambiente 100% seguro
    </span>
  </footer>
</div>
